// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2wZ8y","cell":"ColumnAccessor_cell__1d1VI","firstCellAccent":"ColumnAccessor_firstCellAccent__1c7Jy"};